"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ossUpload = require("@/utils/ossUpload");
var _posterManagement = require("@/api/operationManagement/posterManagement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      dialogVisible: false,
      ruleForm: {
        appId: '2',
        name: '海报',
        platformType: null,
        pic: '',
        enable: 1
      },
      addIsEditor: '',
      id: null
    };
  },
  methods: {
    open: function open(data) {
      this.addIsEditor = data.type;
      if (data.type === 'add') {
        this.ruleForm.platformType = data.platformType;
      } else {
        this.id = data.id;
        this.getPosterApi(data.id);
      }
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.ruleForm = {
        appId: '2',
        name: '海报',
        pic: '',
        platformType: null,
        enable: 1
      };
      this.dialogVisible = false;
    },
    onVerify: function onVerify() {
      if (!this.ruleForm.pic) {
        this.$notify({
          title: '温馨提示',
          message: '请上传图片',
          type: 'warning'
        });
        return;
      }
      if (this.addIsEditor === 'add') {
        this.savePosterApi();
      } else {
        this.updatePosterApi();
      }
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 图片上传
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              this.ruleForm.pic = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    // 保存海报
    savePosterApi: function () {
      var _savePosterApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context2.n = 1;
              return (0, _posterManagement.savePosterApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '添加成功'
                });
                this.$emit('refresh');
                this.onClose();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function savePosterApi() {
        return _savePosterApi2.apply(this, arguments);
      }
      return savePosterApi;
    }(),
    // 更新海报
    updatePosterApi: function () {
      var _updatePosterApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.ruleForm), {}, {
                id: this.id
              });
              _context3.n = 1;
              return (0, _posterManagement.updatePosterApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '更新成功'
                });
                this.$emit('refresh');
                this.onClose();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function updatePosterApi() {
        return _updatePosterApi2.apply(this, arguments);
      }
      return updatePosterApi;
    }(),
    // 查询海报
    getPosterApi: function () {
      var _getPosterApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(id) {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                id: id
              };
              _context4.n = 1;
              return (0, _posterManagement.getPosterApi)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.ruleForm.appId = res.data.appId;
                this.ruleForm.name = res.data.name;
                this.ruleForm.platformType = res.data.platformType;
                this.ruleForm.pic = res.data.pic;
                this.ruleForm.enable = res.data.enable;
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.log(_t4);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function getPosterApi(_x2) {
        return _getPosterApi2.apply(this, arguments);
      }
      return getPosterApi;
    }()
  }
};